import { useEffect, useState } from "react"
import { useFieldArray } from "react-hook-form"
import { Col, Row } from "reactstrap"
import CustomButton from "../../../../layout/CustomButton"
import Form from "./FormFields"

const CommissionOverwrites = ({ register, control, overwrites, errors, setValue, getValues, commissionOverwritesForDel, setCommissionOverwritesForDel }) => {
  const [disableAdd, setDisableAdd] = useState<boolean>(false);
  const { fields, append, remove } = useFieldArray({
    name: "commissionOverwrites",
    control
  })

  useEffect(() => {
    console.log("overwrites :: ", overwrites)
    overwrites?.forEach(({ id, ...rest }) => append({
      id, ...rest
    }))
    if (overwrites[overwrites?.length - 1]?.endRange?.includes("+")) {
      setDisableAdd(true)
    }
  }, [])

  return <Row>
    <>
      <Col sm='12' className="mb-4 mt-4 custom-form-input form-input">
        <div className="font-weight-bold"> Commission Overwrites</div>
      </Col>
      {fields?.map((field: any, index) => (
        <Form
          setCommissionOverwritesForDel={setCommissionOverwritesForDel} commissionOverwritesForDel={commissionOverwritesForDel}
          note={field?.note} percentage={field?.percentage} type={field?.type?.label || field?.type} validDays={field?.validDays}
          id={field?.commissionId || overwrites[index]?.id} setDisableAdd={setDisableAdd} recruiterDealId={field?.recruiterDealId}
          setValue={setValue} register={register} serial={index} errors={errors}
          key={field.id} remove={remove} control={control} getValues={getValues} isLast={index === fields?.length - 1} />))}

      <Col sm='12' className="mb-3 custom-form-input form-input">
        <CustomButton
          buttonText="+ Add Commission"
          className="btn-primary w-100"
          disabled={disableAdd}
          buttonClick={() => {
            append({})
          }}
        />
      </Col>
    </>
  </Row>
}
export default CommissionOverwrites